export default __webpack_public_path__ + "static/media/midcap150-valuation-graph1.5cbe8883.jpg";